// Where "home" is: O1 when signed out (or the onboarding step the draft stopped at), Chat on phones, K1 on desktop.
import { appStore } from './store';
import { currentLayout } from './layout';
import { draftStore } from './screens/onboarding/draft';
import { isOnboarding, type ScreenId } from './router';

export function homeScreen(): ScreenId {
  if (!appStore.get().token) {
    const s = draftStore.get().screen;
    return s && isOnboarding(s) ? s : 'O1';
  }
  return currentLayout() === 'desktop' ? 'K1' : 'C';
}
